import fetchHelper from './fetchHelper.js';

const setTokenToAxios = (token) => {
    fetchHelper.setToken(token);
};

export const getUser = () => {
    try {
        const serialized = localStorage.getItem('user');
        if (!serialized) {
            return undefined;
        }
        const user = JSON.parse(serialized);
        setTokenToAxios(user.token);
        return { user };
    } catch {
        return undefined;
    }
};

export const setUser = (user) => {
    localStorage.setItem('user', JSON.stringify(user));
};

export const removeUser = () => {
    localStorage.removeItem('user');
};

export const toggleRememberMe = (value) => {
    localStorage.setItem('rememberMe', value);
};

export const getFromStorage = (field) => {
    try {
        return localStorage[field] ? localStorage[field] : null;
    } catch {
        throw new Error();
    }
};

export const setFromStorage = (field, value) => {
    try {
        localStorage[field] = value;
    } catch {
        throw new Error();
    }
};
